<template>
  <svg v-bind="$attrs" :data-name="name">
    <use :xlink:href="`#${name}`" />
  </svg>
</template>

<script>
// generate sprite
// useful to add to all colored elements fill/stroke attrs with "currentColor" value; it inherits css color attr from parents

const svgsCtx = require.context('assets/svg/', true, /([\w-]+)\.svg$/);
const svgsUrls = svgsCtx.keys()/*.reduce((svgsUrls, key) => {
  const svg = svgsCtx(key);
  svgsUrls[svg.id] = svg.url;
  return svgsUrls;
}, {})*/;

// it fixes https://stackoverflow.com/questions/24806913/how-can-i-refer-to-an-internal-gradient-definition-inside-an-svg-sprite-symbol
// if you want to use url(#id) inside your svg (linearGradient e.g.) from external sprite, you must append it to the page
fetch('assets/sprite.svg').then(resp => resp.text()).then(svg => {
  const $div = document.createElement('div');
  $div.id = 'sprite.svg';
  $div.innerHTML = svg;
  document.body.append($div);
});

export default {
  name: 'Svg',
  // mounted () {
  //   if (!svgsUrls.includes('./' + this.name + '.svg'))
  //     console.warn(`Svg: icon "${ this.name }" not found in sprite!`);
  // },

  props: {
    name: {
      type: String,
      required: true,
    },
    spriteUrl: {
      type: String,
      // default: '/assets/sprite.svg',
    },
  },
};
</script>
